<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>

        <custom-overlay
            :status="userData_loading"
            @tryAgain="loadLoggedUserData"
            @logout="logout"
        >
        </custom-overlay>

        <div v-if="userData_loading === 1">
            <v-navigation-drawer width="250"
                                 v-model="drawer"
                                 :mini-variant="mini"
                                 app
            >
                <v-list class="pa-1">
                    <v-list-tile v-if="mini" @click.stop="mini = !mini">
                        <v-list-tile-action>
                            <v-icon>chevron_right</v-icon>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-list-tile avatar tag="div">
                        <v-list-tile-avatar>
                            <img :src="companyImage" alt="">
                        </v-list-tile-avatar>

                        <v-list-tile-content>
                            <v-list-tile-title>{{companyName}}</v-list-tile-title>
                        </v-list-tile-content>

                        <v-list-tile-action>
                            <v-btn icon @click.stop="mini = !mini">
                                <v-icon>chevron_left</v-icon>
                            </v-btn>
                        </v-list-tile-action>
                    </v-list-tile>
                </v-list>

                <v-list class="pt-0" dense>
                    <v-divider light></v-divider>
                    <!--Menu items-->
                    <template v-for="route in menuItems">
                        <v-list-tile
                            v-if="canDisplayRoute(route)"
                            :to="route.path" :key="route.title">
                            <v-list-tile-action>
                                <v-icon>{{ route.icon }}</v-icon>
                            </v-list-tile-action>

                            <v-list-tile-content>
                                <v-list-tile-title>{{ route.title }}</v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </template>

                </v-list>

            </v-navigation-drawer>
            <v-toolbar :clipped-left=false app absolute>
                <v-toolbar-side-icon
                        @click.stop="drawer = !drawer"
                ></v-toolbar-side-icon>
                <v-spacer></v-spacer>

                <v-menu
                        v-model="menu"
                        :close-on-content-click="false"
                        :nudge-width="200"
                        offset-x
                >
                    <template v-slot:activator="{ on }">
                        <v-chip v-on="on">
                            <v-avatar style="cursor: pointer">
                                <img :src="userImage" alt="" onerror="this.onerror=null;this.src='images/standart_profile.png';">
                            </v-avatar>
                            <span style="cursor: pointer">{{loggedUser ? loggedUser.name : '???'}}</span>
                        </v-chip>
                    </template>

                    <v-card>
                        <v-list>
                            <v-list-tile avatar>
                                <v-list-tile-avatar>
                                    <img :src="userImage" alt="" onerror="this.onerror=null;this.src='images/standart_profile.png';">
                                </v-list-tile-avatar>

                                <v-list-tile-content>
                                    <v-list-tile-title>{{loggedUser ? loggedUser.name : '???'}}</v-list-tile-title>
                                    <v-list-tile-sub-title>{{loggedUser ? loggedUser.email : '???@???.??'}}</v-list-tile-sub-title>
                                </v-list-tile-content>

                                <v-list-tile-action>
                                    <!--<v-menu bottom left>-->
                                    <!--<template v-slot:activator="{ on }">-->
                                    <!--<v-btn-->
                                    <!--:class="'indigo&#45;&#45;text'"-->
                                    <!--icon-->
                                    <!--v-on="on"-->
                                    <!--&gt;-->
                                    <!--<v-icon >more_vert</v-icon>-->
                                    <!--</v-btn>-->
                                    <!--</template>-->

                                    <!--<v-list>-->
                                    <!--<v-list-tile @click="changePass">-->
                                    <!--<v-icon style="margin-right: 10px">lock</v-icon> <v-list-tile-title>Alterar Senha</v-list-tile-title>-->
                                    <!--</v-list-tile>-->

                                    <!--<v-list-tile @click="changePass">-->
                                    <!--<v-icon style="margin-right: 10px">account_circle</v-icon> <v-list-tile-title>Editar Perfil</v-list-tile-title>-->
                                    <!--</v-list-tile>-->

                                    <!--<v-list-tile @click="changePass">-->
                                    <!--<v-icon style="margin-right: 10px">business</v-icon> <v-list-tile-title>Editar Empresa</v-list-tile-title>-->
                                    <!--</v-list-tile>-->
                                    <!--</v-list>-->
                                    <!--</v-menu>-->

                                </v-list-tile-action>
                            </v-list-tile>
                        </v-list>

                        <v-list>

                            <!--Change Password-->
                            <v-list-tile v-ripple @click="openChangePass()" :disabled="changePassLoading">
                                <v-list-tile-action>
                                    <v-icon style="margin-top: -5px">vpn_key</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-title style="margin-left: -20px">Alterar Senha
                                    <v-progress-circular style="margin-top: -5px; margin-left: 5px" v-if="changePassLoading"
                                        indeterminate
                                        color="primary"
                                        :size="15"
                                        :width="1.5"
                                    ></v-progress-circular>
                                </v-list-tile-title>
                            </v-list-tile>

                            <!--Edit profile-->
                            <v-list-tile v-ripple @click="openUserModal()" :disabled="userModalLoading">
                                <v-list-tile-action>
                                    <v-icon style="margin-top: -5px">account_circle</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-title style="margin-left: -20px">Editar perfil
                                    <v-progress-circular style="margin-top: -5px; margin-left: 5px" v-if="userModalLoading"
                                        indeterminate
                                        color="primary"
                                        :size="15"
                                        :width="1.5"
                                    ></v-progress-circular>
                                </v-list-tile-title>
                            </v-list-tile>

                            <!--Edit Company-->
                            <v-list-tile v-ripple @click="openCompanyModal()" :disabled="companyModalLoading" v-if="isGroupAdmin()">
                                <v-list-tile-action>
                                    <v-icon style="margin-top: -5px">corporate_fare</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-title style="margin-left: -20px;">Editar empresa
                                    <v-progress-circular style="margin-top: -5px; margin-left: 5px" v-if="companyModalLoading"
                                                         indeterminate
                                                         color="primary"
                                                         :size="15"
                                                         :width="1.5"
                                    ></v-progress-circular></v-list-tile-title>
                            </v-list-tile>
                        </v-list>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red"
                                   :loading="signingOut"
                                   :disabled="signingOut"
                                   flat @click="logout">Sair
                                <template v-slot:loader>
                                    <span>a sair...</span>
                                </template>
                                <v-icon color="red" small style="margin-top: -2px; margin-left: 2px" right dark>meeting_room</v-icon>
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-menu>


            </v-toolbar>
            <v-content >
                <v-container fluid>
                    <router-view></router-view>
                </v-container>
            </v-content>
            <!--<v-footer :inset="footer.inset" app>-->
            <!--<a href="https://laciftech.cv/" target="_blank"><span class="px-3">Laciftech</span></a>-->
            <!--</v-footer>-->

            <company-edit></company-edit>

            <user-edit></user-edit>

            <change-logged-user-pass></change-logged-user-pass>

            <!--Snackbar-->
            <v-snackbar v-model="snackbar"
                        bottom
                        right
                        :timeout=3000
                        :color='snackbar_color'
            > {{ text }} <v-btn color="white" flat @click="snackbar = false"><v-icon small>clear</v-icon></v-btn>
            </v-snackbar>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import {routes} from "../../router";
    import {Permissions} from "../../config";
    import {eventBus} from "../../main";
    import CompanyEdit from '../company/FormModal';
    import UserEdit from '../user/FormModal';
    import ChangeLoggedUserPass from '../user/ChangeLoggedUserPass';
    import Vue from 'vue';
    import CustomOverlay from "../extra/CustomOverlay";

    export default {
        name: 'Page',

        created(){
            let vm = this;
            this.leftMenu = [];
            this.loadLoggedUserData();
            this.onUserUpdated(vm);
            this.onCompanyUpdated(vm);
            this.onCheckIfOkFromServer(vm);
        },

        data(){
            return {
                userData_loading: 0,
                Permissions: Permissions,
                signingOut: false,
                drawer: null,
                menuItems: routes[0].children,

                mini: false,
                right: null,

                footer: {
                    inset: false
                },

                menu: false,
                changePassLoading: false,
                companyModalLoading: false,
                userModalLoading: false,

                leftMenu: [],

                //Snackbar
                snackbar: false,
                snackbar_color: 'success',
                timeout: 3000,
                text: '',

                admins: [
                    ['Management', 'people_outline'],
                    ['Settings', 'settings']
                ],
                cruds: [
                    ['Create', 'add'],
                    ['Read', 'insert_drive_file'],
                    ['Update', 'update'],
                    ['Delete', 'delete']
                ]
            }
        },

        components: {
            CustomOverlay,
            CompanyEdit,
            UserEdit,
            ChangeLoggedUserPass,
        },

        watch: {
            userData_loading(){
                this.showOverlay = this.userData_loading !== 1;
            }
        },

        computed: {
            ...mapGetters([
                'getToken'
            ]),

            loggedUser:{
                get() {
                    return this.$store.getters.loggedUser;
                },
                set(value){
                    this.$store.dispatch('loggedUser', value);
                }
            },
            showCompanyModal: {
                get(){
                    return this.$store.getters.getShowCompanyModal;
                },
                set(value){
                    this.$store.dispatch('setShowCompanyModal', value);
                }
            },
            showUserModal: {
                get(){
                    return this.$store.getters.getShowUserModal;
                },
                set(value){
                    this.$store.dispatch('setShowUserModal', value);
                }
            },
            showChangeLoggedUserPasswordModal: {
                get(){
                    return this.$store.getters.getShowChangeLoggedUserPasswordModal;
                },
                set(value){
                    this.$store.dispatch('setShowChangeLoggedUserPasswordModal', value);
                }
            },
            selectedCompany: {
                get(){
                    return this.$store.getters.getSelectedCompany;
                },
                set(value){
                    this.$store.dispatch('setSelectedCompany', value);
                }
            },
            selectedUser: {
                get(){
                    return this.$store.getters.getSelectedUser;
                },
                set(value){
                    this.$store.dispatch('setSelectedUser', value);
                }
            },
            cities: {
                get(){
                    return this.$store.getters.getGCities();
                },
                set(value){
                    this.$store.dispatch('setGCities', value);
                }
            },
            company_types: {
                get(){
                    return this.$store.getters.getGCompanyTypes;
                },
                set(value){
                    this.$store.dispatch('setGCompanyTypes', value);
                }
            },
            company_categories: {
                get(){
                    return this.$store.getters.getGCompanyCategories;
                },
                set(value){
                    this.$store.dispatch('setGCompanyCategories', value);
                }
            },
            groups: {
                get(){
                    return this.$store.getters.getGGroups;
                },
                set(value){
                    this.$store.dispatch('setGGroups', value);
                }
            },
            showOverlay: {
                get(){
                    return this.$store.getters.getShowOverlay;
                },
                set(value){
                    this.$store.dispatch('setShowOverlay', value);
                }
            },
            companyName(){
                try{
                    return this.loggedUser.group.company.name;
                }catch (e) {
                    return '';
                }
            },
            companyImage(){
                try{
                    return this.loggedUser.group.company.image_path;
                }catch (e) {
                    return '';
                }
            },
            userImage(){
                this.consoleLog('this.loggedUser.image_path', this.loggedUser.image_path);
                return this.loggedUser.image_path ? this.loggedUser.image_path : '';
            }
        },

        methods: {
            loadLoggedUserData(){
                this.userData_loading = 0;
                this.$store.dispatch('loggedUserInfos').then(response => {
                    if(!response.data.success){
                        this.showSnackBar('Erro ao carregar as suas informações.', 'error');
                    }
                    this.consoleLog('this.loggedUser', this.loggedUser);
                    this.buildLeftMenu();
                    this.userData_loading = 1;
                }, error => {
                    this.consoleLog(error);
                    this.userData_loading = -1;
                });
            },

            logout(){
                this.signingOut = true;
                this.$store.dispatch('logout')
                    .then(() => {
                        this.$router.push({ name: 'login' });
                        this.menu = false;
                    }).catch(() =>{
                }).finally(()=>{
                    this.signingOut = false;
                });
            },

            canDisplayRoute(route){
                if(route.meta.requiresAdmin && !this.isSuperAdminGroup()) return false;
                if(route.meta.requiresAuth && !this.loggedUser) return false;
                return true;
            },

            onUserUpdated(vm){
                eventBus.$on('onFormUserDone', function (user, isEditing) {
                    if(!isEditing) return;

                    if(vm.loggedUser.id === user.id){
                        vm.loggedUser.name = user.name;
                        vm.loggedUser.bi = user.bi;
                        vm.loggedUser.groups_id = user.groups_id;
                        vm.loggedUser.email = user.email;
                        vm.loggedUser.image = user.image;
                    }
                });
            },

            onCompanyUpdated(vm){
                eventBus.$on('onCompanyAdded', function (company, isEditting) {
                    if(!isEditting) return;

                    // this.consoleLog('CompanyUpdated');
                    // this.consoleLog(company);

                    vm.loggedUser.group.company.name = company.name;
                    vm.loggedUser.group.company.bi = company.bi;
                    vm.loggedUser.group.company.groups_id = company.groups_id;
                    vm.loggedUser.group.company.email = company.email;
                    vm.loggedUser.group.company.contacts_json = company.contacts_json;
                    vm.loggedUser.group.company.fiscal_area_code = company.fiscal_area_code;
                    // vm.loggedUser.group.company.image = company.image;
                    vm.loggedUser.group.company.nib_bi = company.nib_bi;
                    vm.loggedUser.group.company.nib_secundario = company.nib_secundario;
                    vm.loggedUser.group.company.types_company_categories_id = company.types_company_categories_id;
                    vm.loggedUser.group.company.types_company_types_id = company.types_company_types_id;

                });
            },

            onCheckIfOkFromServer(vm){
                eventBus.$on('onCheckIfOkFromServer', function (message, snackbarColor) {
                    vm.showSnackBar(message, snackbarColor);
                    vm.$store.dispatch('logout');
                })
            },

            getCompanyModalInfos(){
                this.companyModalLoading = true;
                Vue.axios.get('company/infos_for_modal')
                    .then(response => {
                        // this.consoleLog(response);
                        if(!response.data.success){
                            this.showSnackBar("Erro ao carregar dados...", 'error');
                        }
                        this.company_types = response.data.response.companyTypes;
                        this.company_categories = response.data.response.companyCategories;
                        this.cities = response.data.response.cities;

                        this.showCompanyModal = true;//open company modal

                    }).catch(error => {
                    this.consoleLog(error);
                    this.showSnackBar("Ocorreu um erro ao preparar edição de empresa", 'error');
                }).finally(()=>{
                    this.companyModalLoading = false;
                    this.menu = false;
                });
            },

            getUserModalInfos(){
                this.userModalLoading = true;
                Vue.axios.get('user/infos_for_modal')
                    .then(response => {
                        // this.consoleLog(response);
                        if(!response.data.success){
                            this.showSnackBar("Erro ao carregar dados", 'error');
                        }
                        this.groups = response.data.response.groups;

                        this.showUserModal = true;//open user modal

                    }).catch(error => {
                    this.consoleLog(error);
                    this.showSnackBar("Ocorreu um erro ao preparar edição de utilizador", 'error');
                }).finally(()=>{
                    this.userModalLoading = false;
                    this.menu = false;
                });
            },


            openChangePass(){
                this.showChangeLoggedUserPasswordModal = true;
            },

            openCompanyModal(){
                eventBus.$emit('onCompanyModalOpen', true, true);
                this.selectedCompany = this.loggedUser.group.company;
                this.getCompanyModalInfos();
            },

            openUserModal(){
                this.selectedUser = this.loggedUser;
                eventBus.$emit('onUserFormOpened', true, false);
                this.getUserModalInfos();
            },

            buildLeftMenu(){
                // for(let i=0; i <= routes.length; i++){
                //     if(!routes[i] || routes[i].name === 'login' || routes[i].name === 'home') continue;
                //     if(!this.loggedUser.group){
                //         // this.consoleLog('---->loggedUser.group is null,');
                //         continue;
                //     }
                //     if(routes[i].name === 'companies' && this.loggedUser.group.id !== 1) continue;
                //
                //     //add the route as menu
                //     this.leftMenu.push(routes[i]);
                // }
            },

            showSnackBar(message, color){
                this.snackbar = true;
                this.text = message;
                this.snackbar_color = color;
            },
        }

    }
</script>

<style>
    #app{
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
    }
</style>
